import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { EpcService } from '../../../../services/epc.service';
import { EpcProjectModel } from '../../../../models/epc-project.model';
import { ProjectFormComponent } from '../../components/project-form/project-form.component';
import { createSubQueryFromObject } from '../../../../../core-frontend-common/misc/query-designer/query-designer-functions';
import { queryFilterTypes, queryOperators } from '../../../../../core-frontend-common/misc/query-designer/query-designer';

@Component({
  selector: 'smart-epc-projects',
  templateUrl: './epc-projects.component.html',
  styleUrls: ['./epc-projects.component.scss']
})
export class EpcProjectsComponent implements OnInit {
  selectedElement: any;

  currentFilter = {
    search: '',
    faculty: null,
    category: null,
    type: null,
    priority: false,
    onlyNonLocked: false
  };

  defaultFilter = {
    search: '',
    faculty: null,
    category: null,
    type: null,
    priority: false,
    onlyNonLocked: false
  };


  projects: EpcProjectModel[] = [];

  checkedProjects: EpcProjectModel[] = [];

  tableData = {
    totalItems: 0,
    page: 1,
    pageSize: 10,
    loading: false
  };

  @ViewChild(ProjectFormComponent, {static: false}) projectDialog: ProjectFormComponent;

  constructor(
    protected epcService: EpcService
  ) { }

  ngOnInit() {
    // this.loadProjects();
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'enter') {
      if (this.selectedElement) {
        this.loadProjects();
      }
    }
    if (event.key.toLowerCase() === 'escape') {
      if (this.selectedElement) {

        if (this.currentFilter.search === this.defaultFilter.search) {
          this.resetFilter();
        } else {
          this.currentFilter.search = '';
        }
      }
    }
  }

  onFocus(event) {
    if (event) {
      this.selectedElement = event.target;
    } else {
      this.selectedElement = null;
    }
  }

  onFocusOut() {
    this.selectedElement = null;
  }

  resetFilter() {
    Object.assign(this.currentFilter, this.defaultFilter);
    this.loadProjects();
  }

  loadProjects() {
    this.checkedProjects = [];

    this.tableData.loading = true;

    const query = {
      search: [],
      isLocked: {}
    };

    const queryDesigner = {
      search: [],
      where: {
        operatorType: 'AND',
        operands: []
      },
      page: this.tableData.page,
      pageSize: this.tableData.pageSize,
      orderBy: [
        {
          field: 'CreatedDatetime',
          order: 'DESC'
        }
      ]
    };

    if (this.currentFilter && this.currentFilter.onlyNonLocked) {
      query.isLocked = createSubQueryFromObject(queryOperators.OR, false, 'isLocked', queryFilterTypes.EQUAL);
    }

    Object.keys(query).forEach(queryItem => {
      if (Object.keys(query[queryItem]).length > 0 && queryItem !== 'search') {
        queryDesigner.where.operands.push(query[queryItem]);
      }
    });

    if (this.currentFilter && this.currentFilter.search && this.currentFilter.search.length > 0) {

      const stringArray = this.currentFilter.search.split(/(\s+)/).filter(function(e) {
        return e.trim().length > 0;
      });
      for (let i = 0; i < stringArray.length; i++) {
        queryDesigner.search.push({
          fields: [],
          value: ''
        });

        queryDesigner.search[i].fields = ['name', 'grantNumber', 'agencyCode', 'agencyName'];

        queryDesigner.search[i].value = stringArray[i];
      }
    }



    this.epcService
      .getAllProjects(queryDesigner)
      .subscribe(v => {
        this.projects = v.items;
        this.tableData.totalItems = v.totalItems;
        this.tableData.loading = false;
      }, e => {
        console.log(e);
        this.tableData.loading = false;
      });
  }

  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
    this.tableData.page = (pageInfo.first + pageInfo.rows) / this.tableData.pageSize;

    this.loadProjects();
  }

  addAction() {
    this.projectDialog.openModal(new EpcProjectModel(), () => {
      this.loadProjects();
    });
  }

  editProjectAction(p: EpcProjectModel) {
    this.projectDialog.openModal(p, () => {
      this.loadProjects();
    });
  }

  projectDeletedAction(e) {
    if (e) {
      this.loadProjects();
    }
  }


}
